module.exports = __webpack_public_path__ + "img/hoomans.4ed7bdac.png";